import { OverlayModule } from '@angular/cdk/overlay';
import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, signal, DOCUMENT } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { CasellaConfigService, ROUTER_URLS } from '@portal/common';
import { ButtonDirective, ClickOutsideDirective, Icons, SCREENS, SvgIconComponent } from '@portal/ui-common';
import { GtmLinkClickDirective } from '@shared/gtm';

interface NavItem {
  label: string;
  url: string;
}

const CSL_IMPORTS = [ButtonDirective, ClickOutsideDirective, SvgIconComponent, GtmLinkClickDirective];

@Component({
  selector: 'csl-header',
  standalone: true,
  imports: [NgOptimizedImage, OverlayModule, RouterLink, RouterLinkActive, ...CSL_IMPORTS],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  private readonly document: Document = inject(DOCUMENT);
  private readonly casellaConfigService = inject(CasellaConfigService);

  public readonly homePageUrl = this.casellaConfigService.config.MAIN_SITE_URL;

  public readonly icons = Icons;
  public readonly desktopInitialWidth = SCREENS.md;
  public readonly navItems: NavItem[] = [{ label: 'Services', url: ROUTER_URLS.root }];
  public readonly isOpen = signal(false);

  public toggleMenu(status: boolean) {
    this.isOpen.set(status);
    if (status) {
      window.addEventListener('resize', this.onResize);
      this.document.body.classList.add('overflow-hidden');
    } else {
      window.removeEventListener('resize', this.onResize);
      this.document.body.classList.remove('overflow-hidden');
    }
  }

  private onResize = (event: Event): void => {
    const window = event?.target as Window;
    const width = window.innerWidth;
    if (this.isOpen() && width >= this.desktopInitialWidth) {
      this.toggleMenu(false);
    }
  };
}
